export default __webpack_public_path__ + "static/media/february.6d6e9f96.png";